module.exports = __webpack_public_path__ + "img/full_right_angle_corner_arrow_line.97b22073.svg";